import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { PaypalObjectDataset } from 'app/model/dataset/paypal.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'PayPalSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(PaypalObjectDataset) }
})
export class PaypalCopySource extends TabularCopySource {
}
